export default () => {
    $(document).on("click",".search__btn",function() {
        $(this).toggleClass('active');
        $('.search-form').toggleClass('active');
    });
}
  